import { blackColor, whiteColor } from 'src/tools/constant';
import { randomNumber } from 'src/tools/helper';
import { generateNewContentPage } from 'src/components/Modules/Components/ContentImageDragItem/tools';
export enum EnumCollapseId {
  megaMenuStyle = 'megaMenuStyle',
}

export enum EColType {
  ContentPage = 'ContentPage',
  NavigationGroup = 'NavigationGroup',
  Product = 'Product',
}

export const fixedCollapse = [EnumCollapseId.megaMenuStyle];

const generateMegaMenuStyle = () => ({
  backgroundColor: blackColor,
  textAndIconColor: whiteColor,
  dividerColor: whiteColor,
  priceColor: 'rgb(210, 0, 0)',
  entranceAnimationUuid: null,
});

const generateCol = () => {
  return {
    columnType: EColType.NavigationGroup,
    ...generateNewContentPage(),
    menuGroups: [],
    salesChannelProduct: null,
  };
};

const generateNewMenu = (count?) => {
  return {
    title: `Mega Menu ${count}`,
    draggableId: randomNumber(),
    linkModule: null,
    menuColumns: [generateCol(), generateCol(), generateCol(), generateCol()],
  };
};

export { generateMegaMenuStyle, generateNewMenu, generateCol };
